import { render, staticRenderFns } from "./event-feedback-add.vue?vue&type=template&id=13b46d24&"
import script from "./event-feedback-add.vue?vue&type=script&lang=js&"
export * from "./event-feedback-add.vue?vue&type=script&lang=js&"
import style0 from "./event-feedback-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports